// Ubicación en el repo: src/lib/mapsLink.js
// Link de Google Maps armado desde la dirección guardada de la sucursal —
// pedido de Nicolás (24-ago-2026, ver DECISIONS.md #104): la dirección
// misma es el hipervínculo (no una línea aparte tipo "ver en el mapa").
// Excepción: sucursales itinerantes (`maps_link_enabled = false` en la
// base, migración 0045) no llevan link automático — su ubicación cambia y
// el staff debe comunicarla manualmente. Hoy la única así es "Óptica
// Comunal Colina", administrable desde Sucursales → Editar.
//
// Se usa acá en el comprobante impreso (receipts.js). El mismo criterio
// se reimplementa en Deno (Edge Functions no pueden importar este módulo)
// en public-agendamiento-create, notify-appointment-reminder y
// send-appointment-reminders — si esto cambia, hay que actualizar los 4
// lugares.
import { esc } from './print';

export function googleMapsUrl(address) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

// mapsLinkEnabled = true por defecto si no viene (mismo criterio que
// isModuleEnabledForBranch en lib/branches.js): mejor no bloquear de más
// por un campo ausente en algún punto viejo del código.
export function addressHtml(address, mapsLinkEnabled) {
  if (!address) return '';
  const safeAddress = esc(address);
  if (mapsLinkEnabled === false) return safeAddress;
  return `<a href="${googleMapsUrl(address)}" style="color:inherit; text-decoration:underline;" target="_blank" rel="noopener noreferrer">${safeAddress}</a>`;
}
